import React from 'react';
import { motion } from 'framer-motion';
const products = [{
  id: 1,
  name: 'חולצת ACID',
  price: '₪250',
  color: 'bg-acid',
  img: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
}, {
  id: 2,
  name: 'קפוצ׳ון VOID',
  price: '₪420',
  color: 'bg-magenta',
  img: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
}, {
  id: 3,
  name: 'מכנסי CARGO',
  price: '₪380',
  color: 'bg-electric',
  img: 'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
}, {
  id: 4,
  name: 'כובע REBEL',
  price: '₪120',
  color: 'bg-white',
  img: 'https://images.unsplash.com/photo-1521369909029-2afed882ba54?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
}, {
  id: 5,
  name: 'ג׳קט CYBER',
  price: '₪650',
  color: 'bg-acid',
  img: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
}, {
  id: 6,
  name: 'תיק NOISE',
  price: '₪290',
  color: 'bg-black text-white',
  img: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
}];
export function Drops() {
  return <section id="DROPS" className="py-20 bg-white brutal-border border-l-0 border-r-0 border-b-0" data-id="element-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <div className="flex justify-between items-end mb-12 border-b-8 border-black pb-4" data-id="element-38">
          <h2 className="text-6xl md:text-8xl font-black uppercase tracking-tighter" data-id="element-39">
            DROPS
          </h2>
          <span className="text-2xl font-bold bg-acid px-4 py-1 brutal-border" data-id="element-40">
            עונה 1
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-41">
          {products.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`brutal-card ${product.color} flex flex-col group brutal-hover`} data-id="element-42">
              <div className="p-4 border-b-4 border-black bg-white" data-id="element-43">
                <div className="aspect-square overflow-hidden brutal-border relative" data-id="element-44">
                  <img src={product.img} alt={product.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-300" data-id="element-45" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" data-id="element-46"></div>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col justify-between" data-id="element-47">
                <div data-id="element-48">
                  <h3 className="text-3xl font-black mb-2" data-id="element-49">{product.name}</h3>
                  <p className="text-2xl font-bold font-archivo" dir="ltr" data-id="element-50">
                    {product.price}
                  </p>
                </div>
                <button className="mt-6 brutal-btn bg-black text-white py-3 w-full text-xl group-hover:bg-white group-hover:text-black transition-colors" data-id="element-51">
                  הוסף לסל
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}